module.exports = __webpack_public_path__ + "img/poster4.cdd181d1.png";